import { Trans } from '@lingui/react/macro';

import Paragraph from '@/design_system/Typography/Paragraph';
import {
  BrandCreationLayout,
  BrandCreationLayoutHeader,
} from '@/layouts/Brand/BrandCreationLayout/BrandCreationLayout';

const Error = () => {
  return (
    <BrandCreationLayout>
      <BrandCreationLayoutHeader />
      <main style={{ paddingTop: '1rem', textAlign: 'center' }}>
        <Paragraph>
          <Trans id="brand.error">Something went wrong. Please try again later.</Trans>
        </Paragraph>
      </main>
    </BrandCreationLayout>
  );
};

export default Error;
